import { render } from "./TipoElem.vue?vue&type=template&id=702c7f2c"
import script from "./TipoElem.vue?vue&type=script&lang=js"
export * from "./TipoElem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__